<template>
    <v-container>
        <div id="divPrint">
            <div>
              <span  style="font-weight: bold">Identificación:</span>
              {{$store.state.patient.identification}}<br>
              <span style="font-weight: bold">Apellidos y nombres:</span>
              {{$store.state.patient.firstLastName}}
              {{$store.state.patient.secondLastName}}
              {{$store.state.patient.firstName}}
              {{$store.state.patient.secondName}} <br>
              <span style="font-weight: bold">Edad:</span>
              {{$store.state.patient.age}}<br>
              <span  style="font-weight: bold">Empresa:</span>
              {{$store.state.patient.company.name}}<br>
              <span  style="font-weight: bold">Puesto de trabajo:</span>
              {{$store.state.patient.jobCompany}}<br>
            </div>
            <table border="1">
                <tbody>
                <tr>
                    <td colspan="3" align="center" bgcolor="#CCCCFF" width="1500px"><b>SCORE FRAMINGHAM</b></td>
                </tr>
                <tr>
                    <td bgcolor="#CCAAFF"><b>Descripción<b></b></b></td>
                    <td bgcolor="#CCAAFF"><b>Valor<b></b></b></td>
                    <td bgcolor="#CCAAFF"><b>Interpretación<b></b></b></td>
                </tr>
                <tr>
                    <td>EDAD:</td>
                    <td>{{this.$store.state.patient.age}}</td>
                    <td>{{getAge()}}</td>
                </tr>
                <tr>
                    <td>COLESTEROL:</td>
                    <td>{{this.$store.state.anamnesis.signosVitales[14].valor}}</td>
                    <td>{{getColesterol()}}</td>
                </tr>
                <tr>
                    <td>HDL:</td>
                    <td>{{this.$store.state.anamnesis.signosVitales[12].valor}}</td>
                    <td>{{getHdl()}}</td>
                </tr>
                <tr>
                    <td title="PRESION SISTÓLICA: Valor  Interpretación: 0 PRESION DIASTÓLICA: Valor  Interpretación: 0">
                        PRESIÓN:
                    </td>
                    <td>{{this.$store.state.anamnesis.signosVitales[1].valor}} /
                        {{this.$store.state.anamnesis.signosVitales[2].valor}}
                    </td>
                    <td>{{getPresion()}}</td>
                </tr>
                <tr>
                    <td>DIABETES:</td>
                    <td>{{this.$store.state.anamnesis.antecedentesPersonales[24].descripcion=='SI'?"SI":"NO"}}</td>
                    <td>{{getDiabetes()}}</td>
                </tr>
                <tr>
                    <td>FUMA:</td>
                    <td>{{this.$store.state.anexoSaludTrabajo.adicciones[1].valor==true?"SI":"NO"}}</td>
                    <td>{{this.$store.state.anexoSaludTrabajo.adicciones[1].valor==true?2:0}}</td>
                </tr>
                <tr>
                    <td colspan="2">SUMA:</td>
                    <td>{{getSuma()}}</td>
                </tr>
                <tr>
                    <td colspan="2">PORCENTAJE:</td>
                    <td>{{getPorcentaje()}}</td>
                </tr>
                <tr>
                    <td colspan="2">SCORE FRAMINGHAM:</td>
                    <td><b>{{getScoreFraminghan()}}</b></td>
                </tr>
                </tbody>
            </table>
          <br>
          <br>
          <br>
            <center><h2><b>Riesgo estimado a los 10 años para enfermedad coronaria</b></h2></center>
            <center><h2><b>Score de puntos Framingham</b></h2></center>
            <center><h3><b>Paso 1</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Edad</b></td>
                    </tr>
                    <tr>
                        <td><b>Años</b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>30-34</td>
                        <td>[-1]</td>
                        <td>[-9]</td>
                    </tr>
                    <tr>
                        <td>35-39</td>
                        <td>[0]</td>
                        <td>[-4]</td>
                    </tr>
                    <tr>
                        <td>40-44</td>
                        <td>[1]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>45-49</td>
                        <td>[2]</td>
                        <td>[3]</td>
                    </tr>
                    <tr>
                        <td>50-54</td>
                        <td>[3]</td>
                        <td>[6]</td>
                    </tr>
                    <tr>
                        <td>55-59</td>
                        <td>[4]</td>
                        <td>[7]</td>
                    </tr>
                    <tr>
                        <td>60-64</td>
                        <td>[5]</td>
                        <td>[8]</td>
                    </tr>
                    <tr>
                        <td>65-69</td>
                        <td>[6]</td>
                        <td>[8]</td>
                    </tr>
                    <tr>
                        <td>70-74</td>
                        <td>[7]</td>
                        <td>[8]</td>
                    </tr>
                    </tbody>
                </table>
            </center>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>

            <center><h3><b>Paso 2</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Colesterol</b></td>
                    </tr>
                    <tr>
                        <td><b>(mg/dl)</b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>&lt; 160</td>
                        <td>[-3]</td>
                        <td>[-2]</td>
                    </tr>
                    <tr>
                        <td>160-199</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>200-239</td>
                        <td>[1]</td>
                        <td>[1]</td>
                    </tr>
                    <tr>
                        <td>240-279</td>
                        <td>[2]</td>
                        <td>[1]</td>
                    </tr>
                    <tr>
                        <td>&gt;= 280</td>
                        <td>[3]</td>
                        <td>[3]</td>
                    </tr>
                    </tbody>
                </table>
            </center>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <center><h3><b>Paso 3</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>HDL</b></td>
                    </tr>
                    <tr>
                        <td><b>(mg/dl)</b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>&lt; 35</td>
                        <td>[2]</td>
                        <td>[5]</td>
                    </tr>
                    <tr>
                        <td>35-44</td>
                        <td>[1]</td>
                        <td>[2]</td>
                    </tr>
                    <tr>
                        <td>45-49</td>
                        <td>[0]</td>
                        <td>[1]</td>
                    </tr>
                    <tr>
                        <td>50-59</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>&gt;= 60</td>
                        <td>[-2]</td>
                        <td>[-3]</td>
                    </tr>
                    </tbody>
                </table>
            </center>

            <center><h3><b>Paso 4</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Presión arterial sistólica</b></td>
                    </tr>
                    <tr>
                        <td><b>(mmHg)</b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>&lt; 120</td>
                        <td>[0]</td>
                        <td>[-3]</td>
                    </tr>
                    <tr>
                        <td>120-129</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>130-139</td>
                        <td>[1]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>140-159</td>
                        <td>[2]</td>
                        <td>[2]</td>
                    </tr>
                    <tr>
                        <td>&gt;= 160</td>
                        <td>[3]</td>
                        <td>[3]</td>
                    </tr>
                    <tr>
                        <td colspan="3"><b>Presión arterial diastólica</b></td>
                    </tr>
                    <tr>
                        <td><b>(mmHg)</b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>&lt; 80</td>
                        <td>[0]</td>
                        <td>[-3]</td>
                    </tr>
                    <tr>
                        <td>80-84</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>85-89</td>
                        <td>[1]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>90-99</td>
                        <td>[2]</td>
                        <td>[2]</td>
                    </tr>
                    <tr>
                        <td>&gt;= 100</td>
                        <td>[3]</td>
                        <td>[3]</td>
                    </tr>
                    </tbody>
                </table>
            </center>

            <center><b>Nota:</b> Cuando la presión sistólica y diastólica presentan diferente puntuación en el score, se
                utiliza el número más alto.
            </center>

            <center><h3><b>Paso 5</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Diabetes</b></td>
                    </tr>
                    <tr>
                        <td><b></b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>No</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>Si</td>
                        <td>[2]</td>
                        <td>[4]</td>
                    </tr>
                    </tbody>
                </table>
            </center>

            <center><h3><b>Paso 6</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Fumador</b></td>
                    </tr>
                    <tr>
                        <td><b></b></td>
                        <td><b>Pts M</b></td>
                        <td><b>Pts F</b></td>
                    </tr>
                    <tr>
                        <td>No</td>
                        <td>[0]</td>
                        <td>[0]</td>
                    </tr>
                    <tr>
                        <td>Si</td>
                        <td>[2]</td>
                        <td>[2]</td>
                    </tr>
                    </tbody>
                </table>
            </center>
            <center><h3><b>Paso 7</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Riesgo de enfermedad coronaria</b></td>
                    </tr>
                    <tr>
                        <td rowspan="2"><b>Pts total</b></td>
                        <td colspan="2"><b>Riesgo a los 10 años</b></td>
                    </tr>
                    <tr>
                        <td><b>Hombres</b></td>
                        <td><b>Mujeres</b></td>
                    </tr>
                    <tr>
                        <td>&lt; -2</td>
                        <td>[2%]</td>
                        <td>[1%]</td>
                    </tr>
                    <tr>
                        <td>[-1]</td>
                        <td>[2%]</td>
                        <td>[2%]</td>
                    </tr>
                    <tr>
                        <td>[0]</td>
                        <td>[3%]</td>
                        <td>[2%]</td>
                    </tr>
                    <tr>
                        <td>[1]</td>
                        <td>[3%]</td>
                        <td>[2%]</td>
                    </tr>
                    <tr>
                        <td>[2]</td>
                        <td>[4%]</td>
                        <td>[3%]</td>
                    </tr>
                    <tr>
                        <td>[3]</td>
                        <td>[5%]</td>
                        <td>[3%]</td>
                    </tr>
                    <tr>
                        <td>[4]</td>
                        <td>[7%]</td>
                        <td>[4%]</td>
                    </tr>
                    <tr>
                        <td>[5]</td>
                        <td>[8%]</td>
                        <td>[4%]</td>
                    </tr>
                    <tr>
                        <td>[6]</td>
                        <td>[10%]</td>
                        <td>[5%]</td>
                    </tr>
                    <tr>
                        <td>[7]</td>
                        <td>[13%]</td>
                        <td>[6%]</td>
                    </tr>
                    <tr>
                        <td>[8]</td>
                        <td>[16%]</td>
                        <td>[7%]</td>
                    </tr>
                    <tr>
                        <td>[9]</td>
                        <td>[20%]</td>
                        <td>[8%]</td>
                    </tr>
                    <tr>
                        <td>[10]</td>
                        <td>[25%]</td>
                        <td>[10%]</td>
                    </tr>
                    <tr>
                        <td>[11]</td>
                        <td>[31%]</td>
                        <td>[11%]</td>
                    </tr>
                    <tr>
                        <td>[12]</td>
                        <td>[37%]</td>
                        <td>[13%]</td>
                    </tr>
                    <tr>
                        <td>[13]</td>
                        <td>[45%]</td>
                        <td>[15%]</td>
                    </tr>
                    <tr>
                        <td>[14]</td>
                        <td>[53%]</td>
                        <td>[18%]</td>
                    </tr>
                    <tr>
                        <td>[15]</td>
                        <td>[53%]</td>
                        <td>[20%]</td>
                    </tr>
                    <tr>
                        <td>[16]</td>
                        <td>[53%]</td>
                        <td>[24%]</td>
                    </tr>
                    <tr>
                        <td>[&gt;= 17]</td>
                        <td>[53%]</td>
                        <td>[27%]</td>
                    </tr>
                    </tbody>
                </table>
            </center>

            <center><h3><b>Paso 8</b></h3></center>
            <center>
                <table border="1" style="text-align:center">
                    <tbody>
                    <tr>
                        <td colspan="3"><b>Interpretación</b></td>
                    </tr>
                    <tr>
                        <td><b>%</b></td>
                        <td><b>Riesgo</b></td>
                    </tr>
                    <tr>
                        <td>[&lt; 10]</td>
                        <td bgcolor="#01DF01">[Riesgo bajo]</td>
                    </tr>
                    <tr>
                        <td>[10-20]</td>
                        <td bgcolor="#F7FE2E">[Riesgo medio]</td>
                    </tr>
                    <tr>
                        <td>[&gt; 20]</td>
                        <td bgcolor="#FF0000">[Riesgo alto]</td>
                    </tr>
                    </tbody>
                </table>
            </center>
        </div>
        <v-btn
                @click="print" dark color="primary">Imprimir
        </v-btn>
    </v-container>
</template>
<script>


    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                editedIndex: -1
            };
        }, methods: {
            getAge() {
                let value = this.$store.state.patient.age
                if (this.$store.state.patient.gender == "M") {
                    if (value >= 30 && value <= 34) {
                        return -1
                    } else if (value >= 35 && value <= 39) {
                        return 0
                    } else if (value >= 40 && value <= 44) {
                        return 1
                    } else if (value >= 45 && value <= 49) {
                        return 2
                    } else if (value >= 50 && value <= 54) {
                        return 3
                    } else if (value >= 55 && value <= 59) {
                        return 4
                    } else if (value >= 60 && value <= 64) {
                        return 5
                    } else if (value >= 65 && value <= 69) {
                        return 6
                    } else if (value >= 70 && value <= 74) {
                        return 7
                    } else {
                        return 0
                    }
                } else {
                    if (value >= 30 && value <= 34) {
                        return -9
                    } else if (value >= 35 && value <= 39) {
                        return -4
                    } else if (value >= 40 && value <= 44) {
                        return 0
                    } else if (value >= 45 && value <= 49) {
                        return 3
                    } else if (value >= 50 && value <= 54) {
                        return 6
                    } else if (value >= 55 && value <= 59) {
                        return 7
                    } else if (value >= 60 && value <= 64) {
                        return 8
                    } else if (value >= 65 && value <= 69) {
                        return 8
                    } else if (value >= 70 && value <= 74) {
                        return 8
                    } else {
                        return 0
                    }
                }

            },
            getColesterol() {
                let value = this.$store.state.anamnesis.signosVitales[14].valor
                if (this.$store.state.patient.gender == "M") {
                    if (value < 160) {
                        return -3
                    } else if (value >= 160 && value <= 199) {
                        return 0
                    } else if (value >= 200 && value <= 239) {
                        return 1
                    } else if (value >= 240 && value <= 279) {
                        return 2
                    } else {
                        return 3
                    }
                } else {
                    if (value < 160) {
                        return -2
                    } else if (value >= 160 && value <= 199) {
                        return 0
                    } else if (value >= 200 && value <= 239) {
                        return 1
                    } else if (value >= 240 && value <= 279) {
                        return 1
                    } else {
                        return 3
                    }
                }

            },
            getHdl() {
                let value = this.$store.state.anamnesis.signosVitales[12].valor
                if (this.$store.state.patient.gender == "M") {
                    if (value < 35) {
                        return 2
                    } else if (value >= 35 && value <= 44) {
                        return 1
                    } else if (value >= 45 && value <= 49) {
                        return 0
                    } else if (value >= 50 && value <= 59) {
                        return 0
                    } else {
                        return -2
                    }
                } else {
                    if (value < 35) {
                        return 5
                    } else if (value >= 35 && value <= 44) {
                        return 2
                    } else if (value >= 45 && value <= 49) {
                        return 1
                    } else if (value >= 50 && value <= 59) {
                        return 0
                    } else {
                        return -3
                    }
                }

            },
            getPresion() {
                if (this.$store.state.patient.gender == "M") {
                    let sistolica = this.$store.state.anamnesis.signosVitales[1].valor
                    let totalSistolica = 0
                    if (sistolica < 120) {
                        totalSistolica = 0
                    } else if (sistolica >= 120 && sistolica <= 129) {
                        totalSistolica = 0
                    } else if (sistolica >= 130 && sistolica <= 139) {
                        totalSistolica = 1
                    } else if (sistolica >= 140 && sistolica <= 159) {
                        totalSistolica = 2
                    } else {
                        totalSistolica = 3
                    }
                    let diastolica = this.$store.state.anamnesis.signosVitales[2].valor
                    let totalDiastolica = 0
                    if (diastolica < 80) {
                        totalDiastolica = 0
                    } else if (diastolica >= 80 && diastolica <= 84) {
                        totalDiastolica = 0
                    } else if (diastolica >= 85 && diastolica <= 89) {
                        totalDiastolica = 1
                    } else if (diastolica >= 90 && diastolica <= 99) {
                        totalDiastolica = 2
                    } else {
                        totalDiastolica = 3
                    }
                    return totalSistolica + totalDiastolica
                } else {
                    let sistolica = this.$store.state.anamnesis.signosVitales[1].valor
                    let totalSistolica = 0
                    if (sistolica < 120) {
                        totalSistolica = -3
                    } else if (sistolica >= 120 && sistolica <= 129) {
                        totalSistolica = 0
                    } else if (sistolica >= 130 && sistolica <= 139) {
                        totalSistolica = 0
                    } else if (sistolica >= 140 && sistolica <= 159) {
                        totalSistolica = 2
                    } else {
                        totalSistolica = 3
                    }
                    let diastolica = this.$store.state.anamnesis.signosVitales[2].valor
                    let totalDiastolica = 0
                    if (diastolica < 80) {
                        totalDiastolica = -3
                    } else if (diastolica >= 80 && diastolica <= 84) {
                        totalDiastolica = 0
                    } else if (diastolica >= 85 && diastolica <= 89) {
                        totalDiastolica = 0
                    } else if (diastolica >= 90 && diastolica <= 99) {
                        totalDiastolica = 2
                    } else {
                        totalDiastolica = 3
                    }
                    return totalSistolica + totalDiastolica
                }
            },

          getDiabetes() {
            if (this.$store.state.patient.gender == "M" && this.$store.state.anamnesis.antecedentesPersonales[24].descripcion == 'SI') {
              return 2
            } else if(this.$store.state.patient.gender == "F" && this.$store.state.anamnesis.antecedentesPersonales[24].descripcion == 'SI')  {
              return 4
            }
            return 0
          },

            getSuma() {
                let a0 = this.getAge()
                let a1 = this.getColesterol()
                let a2 = this.getHdl()
                let a3 = this.getPresion()
                let a4 = this.getDiabetes()
                let a5 = this.$store.state.anexoSaludTrabajo.adicciones[1].valor == true ? 2 : 0
                return a0 + a1 + a2 + a3 + a4 + a5
            },
            getPorcentaje() {
                if (this.$store.state.patient.gender == "M") {
                    let suma = this.getSuma()
                    let porcentaje = 0
                    if (suma < -1) {
                        porcentaje = 2
                    } else if (suma == -1) {
                        porcentaje = 2
                    } else if (suma == 0) {
                        porcentaje = 3
                    } else if (suma == 1) {
                        porcentaje = 3
                    } else if (suma == 2) {
                        porcentaje = 4
                    } else if (suma == 3) {
                        porcentaje = 5
                    } else if (suma == 4) {
                        porcentaje = 7
                    } else if (suma == 5) {
                        porcentaje = 8
                    } else if (suma == 6) {
                        porcentaje = 10
                    } else if (suma == 7) {
                        porcentaje = 13
                    } else if (suma == 8) {
                        porcentaje = 16
                    } else if (suma == 9) {
                        porcentaje = 20
                    } else if (suma == 10) {
                        porcentaje = 25
                    } else if (suma == 11) {
                        porcentaje = 31
                    } else if (suma == 12) {
                        porcentaje = 37
                    } else if (suma == 13) {
                        porcentaje = 45
                    } else if (suma == 14) {
                        porcentaje = 53
                    } else if (suma == 15) {
                        porcentaje = 53
                    } else if (suma == 16) {
                        porcentaje = 53
                    } else if (suma >= 17) {
                      porcentaje = 53
                    }
                    return porcentaje
                } else {

                    let suma = this.getSuma()
                    let porcentaje = 0
                    if (suma < -1) {
                        porcentaje = 1
                    } else if (suma == -1) {
                        porcentaje = 2
                    } else if (suma == 0) {
                        porcentaje = 2
                    } else if (suma == 1) {
                        porcentaje = 2
                    } else if (suma == 2) {
                        porcentaje = 3
                    } else if (suma == 3) {
                        porcentaje = 3
                    } else if (suma == 4) {
                        porcentaje = 4
                    } else if (suma == 5) {
                        porcentaje = 4
                    } else if (suma == 6) {
                        porcentaje = 5
                    } else if (suma == 7) {
                        porcentaje = 6
                    } else if (suma == 8) {
                        porcentaje = 7
                    } else if (suma == 9) {
                        porcentaje = 8
                    } else if (suma == 10) {
                        porcentaje = 10
                    } else if (suma == 11) {
                        porcentaje = 11
                    } else if (suma == 12) {
                        porcentaje = 13
                    } else if (suma == 13) {
                        porcentaje = 15
                    } else if (suma == 14) {
                        porcentaje = 18
                    } else if (suma == 15) {
                        porcentaje = 20
                    } else if (suma == 16) {
                        porcentaje = 24
                    } else if (suma >= 17) {
                      porcentaje = 27
                    }
                    return porcentaje
                }
            },
            getScoreFraminghan() {
                let porcentaje = this.getPorcentaje()
                let respuesta = ""
                if (porcentaje < 10) {
                  respuesta = "[Riesgo bajo]"
                } else if (porcentaje >= 10 && porcentaje <= 20) {
                    respuesta = "[Riesgo medio]"
                } else if (porcentaje > 20){
                    respuesta = "[Riesgo alto]"
                }
                return respuesta
            },
            print() {
                var divToPrint = document.getElementById('divPrint');
                var newWin = window.open('', 'Print-Window');
                newWin.document.open();
                newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');
                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 10);
            }

        },
        computed: {},
        beforeCreate() {
            this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                for (let i = 0; i < this.$store.state.anamnesisList.length; i++) {
                    this.$store.state.anamnesis = JSON.parse(this.$store.state.anamnesisList[i].value)
                }
                this.$store.dispatch('getPatientJobAndHealthByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                    for (let i = 0; i < this.$store.state.workAndHealthList.length; i++) {
                        this.$store.state.anexoSaludTrabajo = JSON.parse(this.$store.state.workAndHealthList[i].value)
                    }
                    this.$store.state.scoreFraminghan = this.getScoreFraminghan() +" "+ this.getSuma()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            }, error => {
                this.$store.state.progress = false;
                this.$store.state.dialogError = true;
            })
        },

        created() {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/metabolico/ScoreFraminghan.vue